(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('test-schedule', {
                parent: 'testing',
                url: '/test-schedule',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.testSchedule.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/test-schedule/test-schedule.html',
                        controller: 'TestScheduleController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    itemsPerPageChosen: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates : $stateParams.predicates,
                            filter: $stateParams.listFilter,
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('testSchedule');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('test-schedule.detail', {
                parent: 'test-schedule',
                url: '/test-schedule/{id}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.testSchedule.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/test-schedule/test-schedule-detail.html',
                        controller: 'TestScheduleDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('testSchedule');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TestSchedule', function ($stateParams, TestSchedule) {
                        return TestSchedule.get({id: $stateParams.id});
                    }]
                }
            })
            .state('test-schedule.delete', {
                parent: 'test-schedule',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/test-schedule/test-schedule-delete-dialog.html',
                        controller: 'TestScheduleDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TestSchedule', function (TestSchedule) {
                                return TestSchedule.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('test-schedule', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('test-schedule.resume', {
                parent: 'test-schedule',
                url: '/{id}/resume',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/test-schedule/test-schedule-resume-dialog.html',
                        controller: 'TestScheduleResumeController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TestSchedule', function (TestSchedule) {
                                return TestSchedule.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('test-schedule', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('test-schedule.failed-tests', {
                parent: 'test-schedule',
                url: '/{id}/failed-tests',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.testSchedule.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/test-schedule/test-schedule-failed-tests.html',
                        controller: 'TestScheduleFailedTestsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates : $stateParams.predicates,
                            filter: $stateParams.listFilter,
                            objects: $stateParams.objects
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('testSchedule');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ObjectTestResult', function ($stateParams, ObjectTestResult) {
                        return ObjectTestResult.numberOfTestsBySchedule({id: $stateParams.id}).$promise;
                    }],
                    testSchedule: ['$stateParams', 'TestSchedule', function ($stateParams, TestSchedule) {
                        return TestSchedule.get({id: $stateParams.id});
                    }]
                }
            })
            .state('test-schedule.new', {
                parent: 'test-schedule',
                url: '/new',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.testSchedule.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/test-schedule/test-schedule-dialog.html',
                        controller: 'TestScheduleDialogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    fleet: {value: null},
                    objType: {value: null},
                    tests: {value: null},
                    testSchedule: {value: null},
                    name: {value: null}
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('testSchedule');
                        $translatePartialLoader.addPart('objectTestSetting');
                        return $translate.refresh();
                    }],
                    name: ['$stateParams', function ($stateParams) {
                        return $stateParams.name;
                    }],
                    fleet: ['$stateParams', function ($stateParams) {
                        return $stateParams.fleet;
                    }],
                    objType: ['$stateParams', function ($stateParams) {
                        return $stateParams.objType;
                    }],
                    tests: ['$stateParams', function ($stateParams) {
                        return $stateParams.tests;
                    }],
                    tabFleets: ['TabFleets', function (TabFleets) {
                        return TabFleets.query().$promise;
                    }],
                    testSchedule: ['$stateParams', function ($stateParams) {
                        return $stateParams.testSchedule;
                    }]
                }
            })
            .state('test-schedule.new-next', {
                parent: 'test-schedule',
                url: '/new/next',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.testSchedule.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/test-schedule/test-schedule-dialog-next.html',
                        controller: 'TestScheduleDialogNextController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    fleet: null,
                    objType: null,
                    tests: null,
                    include: false,
                    name: null,
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('testSchedule');
                        $translatePartialLoader.addPart('tabObjects');
                        return $translate.refresh();
                    }],
                    name: ['$stateParams', function ($stateParams) {
                        return $stateParams.name;
                    }],
                    fleet: ['$stateParams', function ($stateParams) {
                        return $stateParams.fleet;
                    }],
                    objType: ['$stateParams', function ($stateParams) {
                        return $stateParams.objType;
                    }],
                    tests: ['$stateParams', function ($stateParams) {
                        return $stateParams.tests;
                    }],
                    include: ['$stateParams', function ($stateParams) {
                        return $stateParams.include;
                    }],
                    objects: ['$stateParams', 'ListObjByObjTypeAndFleet', function ($stateParams, ListObjByObjTypeAndFleet) {
                        return ListObjByObjTypeAndFleet.query({
                            typeId: $stateParams.objType.id,
                            fleetId: $stateParams.fleet.id,
                            size: 2000
                        });
                    }],
                    testSchedule: ['$stateParams', function ($stateParams) {
                        return $stateParams.testSchedule;
                    }]
                }
            })
            .state('test-schedule.edit', {
                parent: 'test-schedule',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.testSchedule.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/test-schedule/test-schedule-dialog.html',
                        controller: 'TestScheduleDialogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    fleet: {value: null},
                    objType: {value: null},
                    tests: {value: null},
                    name: {value:null},
                    include: false,
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('testSchedule');
                        $translatePartialLoader.addPart('objectTestSetting');
                        return $translate.refresh();
                    }],
                    name: ['$stateParams', function ($stateParams) {
                        return $stateParams.name;
                    }],
                    fleet: ['$stateParams', function ($stateParams) {
                        return $stateParams.fleet;
                    }],
                    objType: ['$stateParams', function ($stateParams) {
                        return $stateParams.objType;
                    }],
                    tests: ['$stateParams', function ($stateParams) {
                        return $stateParams.tests;
                    }],
                    tabFleets: ['$stateParams', function ($stateParams) {
                        return $stateParams.tabFleets;
                    }],
                    include: ['$stateParams', function ($stateParams) {
                        return $stateParams.include;
                    }],
                    testSchedule: ['$stateParams', 'TestSchedule', function ($stateParams, TestSchedule) {
                        return TestSchedule.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('test-schedule.edit-next', {
                parent: 'test-schedule',
                url: '/{id}/edit/next',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.testSchedule.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/test-schedule/test-schedule-dialog-next.html',
                        controller: 'TestScheduleDialogNextController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    fleet: {value: null},
                    objType: {value: null},
                    tests: {value: null},
                    testSchedule: {value: null},
                    name: {value: null},
                    include: false,
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('testSchedule');
                        $translatePartialLoader.addPart('tabObjects');
                        return $translate.refresh();
                    }],
                    id: ['$stateParams', function ($stateParams) {
                       return $stateParams.id;
                    }],
                    name: ['$stateParams', function ($stateParams) {
                        return $stateParams.name;
                    }],
                    fleet: ['$stateParams', function ($stateParams) {
                        return $stateParams.fleet;
                    }],
                    objType: ['$stateParams', function ($stateParams) {
                        return $stateParams.objType;
                    }],
                    tests: ['$stateParams', function ($stateParams) {
                        return $stateParams.tests;
                    }],
                    include: ['$stateParams', function ($stateParams) {
                        return $stateParams.include;
                    }],
                    objects: ['$stateParams', 'ListObjByObjTypeAndFleet', function ($stateParams, ListObjByObjTypeAndFleet) {
                        return ListObjByObjTypeAndFleet.query({
                            typeId: $stateParams.objType.id,
                            fleetId: $stateParams.fleet.id,
                            size: 2000
                        }).$promise;
                    }],
                    testSchedule: ['$stateParams', function ($stateParams) {
                        return $stateParams.testSchedule;
                    }]
                }
            });
    }

})();
